import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { MfaModel } from '@models/mfa.model';

@Injectable()
export class MfaService {

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<{ list: MfaModel.Document[] }> {
    return this.http.get<{ list: MfaModel.Document[] }>(api.users.mfaList);
  }

}
